import TextInputField from "../../../Fields/TextInputField";

export default function CompanyFields({ companyName, onChange }) {
  return (
    <TextInputField
      label="Company Name"
      placeholder="Add Company Name"
      value={companyName}
      onChange={onChange("companyName")}
      className="pb-4"
    />
  );
}
